import React from 'react';

import { type AppRecContext } from '../../../common/types';
import { AppRecommendationsContext } from '../index';
import { type AppRecommendationsProviderValue } from '../types';

export interface UseAppRecommendationsProvider {
	endpoint: string | undefined;
	contextResolver: (() => AppRecContext) | AppRecContext;
	onEvents: AppRecommendationsProviderValue['onEvents'];
}

const useAppRecommendationsProvider = (): UseAppRecommendationsProvider => {
	const { onEvents, contextResolver, endpoint } =
		React.useContext<AppRecommendationsProviderValue>(AppRecommendationsContext);

	return { onEvents, contextResolver, endpoint };
};

export default useAppRecommendationsProvider;
